<template>
  <el-aside
    width="200px"
    class="layout-sider-nav">
    <el-menu
      :default-active="defaultActive"
      :unique-opened="true"
      background-color="#3F3F3F"
      text-color="#BFCBD9"
      active-text-color="#fff">
      <template v-for="(menu) in menuData">
        <el-submenu
          v-if="menu.children"
          :key="menu.activePath + ''"
          :index="menu.activePath + ''">
          <span slot="title">{{ menu.menuName }}</span>
          <!-- <el-menu-item-group> -->
          <el-menu-item
            v-for="(children) in menu.children"
            :key="children.activePath + ''"
            :index="children.activePath + ''"
            @click="openUrl(children.funcAddress)">{{ children.menuName }}</el-menu-item>
          <!-- </el-menu-item-group> -->
        </el-submenu>
        <el-menu-item
          v-else
          :key="menu.activePath + ''"
          :index="menu.activePath + ''"
          @click="openUrl(menu.funcAddress)">
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapState } from 'vuex'
// const Menu = {
//   '/vendors': ['/vendors'],
//   '/requirements': ['/requirements'],
//   '/labs': ['/labs'],
//   '/sample-address': ['/sample-address'],
//   '/accounts': ['/accounts'],
//   '/stat': ['/stat'],
//   '/address-book': ['/address-book'],
//   '/service-categorys': ['/service-categorys'],
//   '/industry-categorys': ['/industry-categorys'],
//   '/subordinate-company': ['/subordinate-company'],
//   '/sample-code': ['/sample-code'],
//   '/acceptance-form': ['/acceptance-form']
// }
export default {
  name: 'LayoutSider',
  components: {},
  data() {
    return {
      // defaultActive: '-1'
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      menu: (state) => state.account.menu
    }),
    defaultActive() {
      return this.$route.meta.activePath
    },
    menuData() {
      const activeTopPath = this.$route.meta.activeTopPath
      const menu = this.menu.find(s => s.activePath === activeTopPath) || {}
      return menu.children || []
    }
  },
  // watch: {
  //   $route() {
  //     this.initMenu()
  //   }
  // },
  // created() {
  //   this.initMenu()
  // },
  methods: {
    openUrl(url) {
      this.$router.push(url)
    }
    // initMenu() {
    //   console.log('initMenu')
    //   const path = this.$route.path
    //   this.menuData.forEach((item) => {
    //     if (item.funcAddress) {
    //       if ((Menu[item.funcAddress] || []).indexOf(path) > -1) {
    //         this.defaultActive = item.menuId + ''
    //       }
    //     } else {
    //       item.children.forEach((sItem) => {
    //         if (sItem.funcAddress) {
    //           if ((Menu[sItem.funcAddress] || []).indexOf(path) > -1) {
    //             this.defaultActive = sItem.menuId + ''
    //           }
    //         }
    //       })
    //     }
    //   })
    // }
  }
}
</script>
<style lang="stylus">
.layout-sider-nav {
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  background-color: #3F3F3F;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.5);
  z-index: 10;

  .el-menu {
    border-right: none;

    // .el-menu-item.is-active {
    //   background-color: #1890ff !important;
    // }

    // .el-menu-item-group__title {
    //   display: none;
    // }

    // .el-menu-item-group .el-menu-item:not(.is-active) {
    //   background-color: #000c17 !important;
    // }
  }

  // .sider-logo {
  //   height: 60px;
  //   color: #fff;
  //   font-size: 20px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   font-weight: 600;
  // }
}
</style>
